<template>
    <div v-if="false"></div>
</template>

<script>
import GeoJSON from 'ol/format/GeoJSON'
import Select from 'ol/interaction/Select'
import VectorSource from 'ol/source/Vector'
import { click } from 'ol/events/condition'
import { getStyle } from '../../styles'

const geoJSON = new GeoJSON()

export default {
    name: 'SelectInteraction',
    inject: ['map'],
    mounted() {
        this.select = new Select({
            condition: click,
            layers: (layer) => layer.get('selectable'),
            style: (feature) => {
                return getStyle(this.map, 'school', feature, true)
            },
        })

        this.select.on('select', (e) => {
            const features = e.target.getFeatures().getArray()

            if (features.length === 0) {
                this.$emit('select', null)
                return
            }

            const feature = features[0]

            this.$emit('select', {
                ...feature.getProperties(),
                geometry: geoJSON.writeGeometryObject(feature.getGeometry()),
            })
        })

        this.map.addInteraction(this.select)
    },
    unmounted() {
        this.map.removeInteraction(this.select)
    },
    props: {
        selected: Object,
    },
    watch: {
        selected(selected) {
            this.select.getFeatures().clear()

            if (!selected) {
                return
            }

            this.map.getLayers().forEach((layer) => {
                const source = layer.getSource()
                if (source instanceof VectorSource) {
                    const selectedFeature = source.getFeatureById(selected.id)
                    if (selectedFeature) {
                        this.select.getFeatures().push(selectedFeature)
                    }
                }
            })
        },
    },
}
</script>

<style scoped></style>
